export default "__VITE_ASSET__Bqgmb7KP__"